import { ChemicalTypeService, ConsumableService } from '@general/proxy/general/controllers';
import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const CHEMICAL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('standardAcceptedDeviation', 'Entity.Chemical.StandardAcceptedDeviation')
    .required()
    .decimal(2,18)
    .build(),
  FieldBuilder
    .foreignKey('chemicalTypeId', 'Entity.ChemicalType', ChemicalTypeService)
    .required()
    .displayFromNested('chemicalType.name')
    .sortBy('chemicalType.name') 
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.Consumable', ConsumableService)
    .required()
    .displayFromNested('consumable.name')
    .sortBy('consumable.name')
    .hideInChildForms()
    .build(),
];

export const CHEMICAL_CONFIG = {
  entityName: 'Chemical',
  localizationKey: 'General::Entity.Chemical',
  fields: CHEMICAL_FIELDS,
  permission: 'GeneralConsumables.Chemicals',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
